

// Утилита для отображения флагов - всегда возвращает текстовые коды
export const getFlagForLanguage = (language: string): string => {
  switch (language) {
    case 'ru-RU':
      return 'RU';
    case 'en-EN':
      return 'EN';
    case 'es-ES':
      return 'ES';
    case 'de-DE':
      return 'DE';
    case 'fr-FR':
      return 'FR';
    default:
      return 'EN';
  }
};


